// extracted by mini-css-extract-plugin
export default {"teamMembers":"TeamMembers_teamMembers__8nHO6","cardGrid":"TeamMembers_cardGrid__z36Hh","card":"TeamMembers_card__9753D","centeredCard":"TeamMembers_centeredCard__vouN8"};